export interface ICOLOR {
  color: string,
  theme: string
}

export interface ITranslateColors {
  value: string,
  name: string
}

// added new color and new theme here
export const colorsTheme: ICOLOR[] = [
  { color: 'Amarelo', theme: 'yellow-theme' },
  { color: 'Azul', theme: 'default-theme' },
  { color: 'Cinza', theme: 'gray-theme' },
  { color: 'Dourado', theme: 'golden-theme' },
  { color: 'Laranja', theme: 'orange-theme' },
  { color: 'Preto', theme: 'black-theme' },
  { color: 'Roxo', theme: 'purple-theme' },
  { color: 'Verde', theme: 'green-theme' },
  { color: 'Vermelho', theme: 'red-theme' },
]
